import { useParams, Navigate } from "react-router-dom";
import Seo from "@/components/Seo";
import SimulationExperience from "@/components/SimulationExperience";
import { findSimulation } from "@/data/simulations";

// Data-driven resolver for /simulations/:slug. Renders the simulation experience
// ONLY for genuinely AVAILABLE catalogue simulations; unknown/coming-soon slugs
// never render a valid simulation or an indexable thin page. SEO metadata is
// generated from the catalogue so future available simulations need no code changes.
export default function SimulationRoute() {
  const { slug } = useParams();
  const sim = findSimulation(slug);

  if (!sim || sim.status !== "available" || !sim.route) {
    return <Navigate to="/simulations" replace />;
  }

  const SITE = "https://adaptience.com";
  const url = `${SITE}/simulations/${sim.slug}`;
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
        { "@type": "ListItem", position: 2, name: "Simulations", item: `${SITE}/simulations` },
        { "@type": "ListItem", position: 3, name: sim.title, item: url },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "CreativeWork",
      name: sim.title,
      description: sim.seoDescription,
      url,
      image: sim.ogImage,
      isPartOf: { "@type": "WebSite", name: "Adaptience™", url: `${SITE}/` },
    },
  ];

  return (
    <>
      <Seo
        title={sim.seoTitle}
        description={sim.seoDescription}
        canonical={`/simulations/${sim.slug}`}
        ogTitle={sim.ogTitle}
        ogDescription={sim.ogDescription}
        ogImage={sim.ogImage}
        jsonLd={jsonLd}
      />
      <SimulationExperience sim={sim} />
    </>
  );
}
